import { render, staticRenderFns } from "./exaReturnDiglog.vue?vue&type=template&id=0857f179&scoped=true"
import script from "./exaReturnDiglog.vue?vue&type=script&lang=js"
export * from "./exaReturnDiglog.vue?vue&type=script&lang=js"
import style0 from "./exaReturnDiglog.vue?vue&type=style&index=0&id=0857f179&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0857f179",
  null
  
)

export default component.exports